module.exports = __webpack_public_path__ + "static/media/14.701ed2bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/14.png
// module id = 516
// module chunks = 0